<template>
  <div class="dropdown" :class="{ active: isActive, fullwidth }" @click="handleClick">
    <div class="trigger">
      <slot />
    </div>

    <div class="content">
      <slot name="content" />
    </div>

    <div class="backdrop" />
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  props: {
    fullwidth: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: this.active,
    }
  },
  methods: {
    handleClick: function () {
      this.isActive = !this.isActive
    },
  },
}
</script>
<style scoped lang="scss">
$dropdown-zindex: 1000;
$backdrop-zindex: $dropdown-zindex - 1;

.dropdown {
  position: relative;

  .content {
    @include custom-scrollbar($secondary);

    max-height: 25rem;
    overflow-y: auto;
    background: #fff;
    border-radius: 0.25rem;
    box-shadow: 0 0 1rem 0.15rem rgba(#000, 0.15);
    position: absolute;
    top: 100%;

    opacity: 0;
    pointer-events: none;
    transition: opacity 250ms;
  }

  &.active .trigger {
    z-index: $dropdown-zindex;
    position: relative;
  }

  &.active .content {
    opacity: 1;
    pointer-events: all;
    z-index: $dropdown-zindex;
  }

  &.fullwidth .content {
    left: 0;
    right: 0;
  }

  &.active .backdrop {
    z-index: $backdrop-zindex;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
}
</style>
